import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismCheckbox, PrismRadioGroup } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelBudgetForecastDateRange from 'lumen/components/hotel/budget-forecast/date-range';
import type { DownloadOptions } from 'lumen/components/settings/budget-forecast/upload-download-modal';
import type { DateGranularity } from 'lumen/utils/constants/budget-forecast-constants';

interface SettingsBudgetForecastUploadDownloadModalDownloadTemplateSignature {
  Args: {
    downloadOptions: DownloadOptions;
    updateDownloadOptions: (options: DownloadOptions) => void;
    view: 'budget' | 'forecast';
  };
}

export default class SettingsBudgetForecastUploadDownloadModalDownloadTemplate extends Component<SettingsBudgetForecastUploadDownloadModalDownloadTemplateSignature> {
  @action
  onGranularityChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value as DateGranularity;
    this.updateDownloadOptions({ granularity: value });
  }

  @action
  toggleIncludeSegments(): void {
    const includeSegments = !this.args.downloadOptions.includeSegments;
    this.updateDownloadOptions({ includeSegments });
  }

  @action
  updateDownloadOptions(options: Partial<DownloadOptions>): void {
    this.args.updateDownloadOptions({
      ...this.args.downloadOptions,
      ...options,
    });
  }

  <template>
    <div class="flex flex-col gap-300">
      <label class="heading-4">
        {{t "general.granularity"}}
      </label>

      <PrismRadioGroup
        @isHorizontal={{true}}
        @name="granularity"
        @onChange={{this.onGranularityChange}}
        @value={{@downloadOptions.granularity}}
        as |RadioGroup|
      >
        <RadioGroup.input @value="day">
          {{t "general.day"}}
        </RadioGroup.input>
        <RadioGroup.input @value="month">
          {{t "general.month"}}
        </RadioGroup.input>
      </PrismRadioGroup>

      <HotelBudgetForecastDateRange
        @endDate={{@downloadOptions.endDate}}
        @granularity={{@downloadOptions.granularity}}
        @onChange={{this.updateDownloadOptions}}
        @startDate={{@downloadOptions.startDate}}
        class="ml-600"
      />
    </div>

    <div class="flex flex-col gap-300">
      <label class="heading-4">
        {{t "general.advanced_options"}}
      </label>

      <PrismCheckbox
        @checked={{@downloadOptions.includeSegments}}
        @onChange={{this.toggleIncludeSegments}}
      >
        {{t "revenue_insight.budget.include_segments"}}
      </PrismCheckbox>
    </div>
  </template>
}
